






















































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Membres from '@/components/Group/Membres.vue'
import Groupe from '@/components/Groups/Groupe.vue'
import { getBoUrl } from '@/api/http-constants'
import orderBy from 'lodash/orderBy'
import take from 'lodash/take'
import { IMember } from '@/types/member'
import { UserModule } from '@/store/modules/user'
import AperMembres from '@/components/Groups/AperMembres.vue'
import SmoothReflow from '@/components/_transitions/SmoothReflow.vue'
import ButtonWithTooltip from '@/components/Groups/ButtonWithTooltip.vue'
import reverse from 'lodash/reverse'
import { ApiService } from '../../api/api.service'
import { getOperationID } from '../../api/operations'
import get from 'lodash/get'
import { tooltipTailleCopro } from '@/data/tooltips'
import { formatBigInteger } from '@/filters/numbers'

@Component({
    components: {
        Membres,
        Groupe,
        AperMembres,
        SmoothReflow,
        ButtonWithTooltip,
    },
    filters: {
        formatBigInteger,
    },
})
export default class AperGr extends Vue {
    @Prop() private id: number
    @Prop({ type: Boolean, default: false }) private disabledJoinGroup
    motivation: string = ''
    boUrl = getBoUrl()
    userID: number
    tabs = ['Groupe', 'Membres']
    currentTab: 'Groupe' | 'Membres' = 'Groupe'
    smoothReflowSettings = {
        transitionEvent: {
            selector: '.transitionTarget',
        },
    }
    group = null
    phase: number = null

    @Watch('id')
    async onID() {
        this.getInfos()
    }

    @Watch('group')
    @Watch('currentTab')
    async refreshTooltip() {
        await this.$nextTick()
        setTimeout(() => {
            ;(<any>$('.popover-dismiss')).popover({
                trigger: 'hover',
                container: 'body',
                boundary: 'window',
            })
        }, 300)
    }

    get tooltipTailleCopro() {
        return tooltipTailleCopro
    }

    async getInfos() {
        if (!this.id) {
            this.group = null
            this.phase = null
            return
        }

        const apiService = new ApiService()
        const resp = await apiService.getGroup(this.id)
        const group = resp.data

        const opeID = await getOperationID()

        const opeResp = await apiService.getOperation(opeID)
        const ope = opeResp.data
        const phase = ope.phase === 0 || ope.phase === 4 ? 1 : ope.phase

        this.phase = phase
        this.group = group
        this.ope = ope

        this.$emit('loaded')
    }

    ope: any = null

    get estimativPriceGlobal() {
        return (
            this.group.group.surface *
            (this.group.group.isExterior
                ? this.ope.outdoorFloorPrice
                : this.ope.mediumPrice)
        )
    }

    get estimativPricePerPerson() {
        const price =
            this.group.group.surface *
            (this.group.group.isExterior
                ? this.ope.outdoorFloorPrice
                : this.ope.mediumPrice)

        let estimativPricePerPerson = price / this.group.group.wishedCopros
        return estimativPricePerPerson
    }

    get members(): IMember[] {
        if (!this.group) {
            return []
        }

        const _members = this.group.users.filter(user => {
            return user.state === 'member'
        })

        const members: IMember[] = _members.map(x => {
            const member: IMember = {
                id: x.id,
                name: x.name,
                owner: this.group.group.owner.id === x.id,
                famillyMembers: x.famillyMembers,
                hobbies: x.hobbies,
                sharedSpaces: x.sharedSpaces,
                identikits: x.identikits,
                comment: x.comment,
            }
            return member
        })
        return members
    }

    // get hobbies() {
    //     /**
    //      * On compte les hobbies
    //      */
    //     let hobbies = {}
    //     this.group.users.forEach(user => {
    //         user.hobbies.forEach(hobby => {
    //             if (!hobbies[hobby.name]) {
    //                 hobbies[hobby.name] = 1
    //             } else {
    //                 hobbies[hobby.name]++
    //             }
    //         })
    //     })

    //     /**
    //      * On transform en tableau
    //      */
    //     const hobbiesArray = Object.keys(hobbies).map(x => {
    //         return {
    //             name: x,
    //             count: hobbies[x],
    //         }
    //     })

    //     // On trie du plus grand au plus petit
    //     const hobbiesFinal = orderBy(hobbiesArray, ['count'], ['desc'])

    //     // On limit à 12 items
    //     const hobbiesFirst12 = take(hobbiesFinal, 12)

    //     return hobbiesFirst12
    // }

    /**
     * Récupération de l'état du user dans l'inscription de ce groupe
     */
    get state() {
        if (!this.userID || !this.group) {
            return ''
        }

        const users = reverse(this.group.users)
        const userGroup = users.find(u => u.id === this.userID)
        if (userGroup) {
            return userGroup.state
        }

        return ''
    }

    async quitGroup() {
        const apiService = new ApiService()
        try {
            await apiService.deleteUserFromGroup(
                this.group.group.id,
                this.userID
            )

            const users = reverse(this.group.users)
            const userGroup = users.find(u => u.id === this.userID)
            const index = this.group.users.indexOf(userGroup)
            if (index !== -1) {
                this.group.users.splice(index, 1)
            }

            this.$emit('alert', {
                type: 'success',
                message: 'Retrait effectué',
            })

            this.$emit('quit', this.group.group.id)
        } catch (error) {
            this.$emit('alert', {
                type: 'danger',
                message: 'Erreur lors de la demande de retrait',
            })
        }
    }

    handleJoin() {
        if (this.motivation.trim() !== '' || this.group.group.isPriority) {
            this.handleJoinGroup({
                group: this.group,
                motivation: this.motivation,
            })
        }
    }

    async handleJoinGroup(obj) {
        const apiService = new ApiService()

        const req = {
            user: this.userID,
            motivation: obj.motivation,
        }

        try {
            const resp = await apiService.postJoinGroup(obj.group.group.id, req)
            const data = resp.data

            /**
             * On met à jour le status de l'utilisateur dans les groups si
             * présent, sinon on l'ajoute avec le nouveau status
             */
            const userGroup = obj.group.users.find(
                user => user.id === this.userID
            )
            if (userGroup) {
                userGroup.state = data.state
            } else {
                obj.group.users.push({
                    ...data.user,
                    state: data.state,
                })
            }

            this.$emit('alert', {
                type: 'success',
                message: 'Demande effectuée',
            })
            this.$emit('join', {
                groupID: this.group.group.id,
                userData: data,
            })
        } catch (error) {
            const message = get(
                error,
                'data.message',
                'Impossible de vous joindre au groupe'
            )

            this.$emit('alert', {
                type: 'danger',
                message,
            })
        }
    }

    async created() {
        this.getInfos()

        this.userID = UserModule.userInfos.id
    }
}
